var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.09,
    height: 27.233,
    viewBox: "0 0 22.09 27.233",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M18806.295-7817.267h0a24.669,24.669,0,0,1-5.145-4.043,19.756,19.756,0,0,1-3.539-4.847,14.387,14.387,0,0,1-1.609-6.546,10.307,10.307,0,0,1,10.295-10.295,10.307,10.307,0,0,1,10.295,10.295,14.387,14.387,0,0,1-1.609,6.546,19.756,19.756,0,0,1-3.539,4.847,24.723,24.723,0,0,1-5.145,4.043h0Zm.2-20.235a4,4,0,0,0-4,4,4,4,0,0,0,4,4,4,4,0,0,0,4-4A4,4,0,0,0,18806.5-7837.5Z",
    transform: "translate(-18795.25 7843.749)",
    fill: "none",
    stroke: "#0a1e5b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.e08b2d11ff378bf663608718d51fd04a.svg";
export { ForwardRef as ReactComponent };